import { Card, CardHeader, CardContent, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { TrendingUp, TrendingDown } from "lucide-react";

export function formatCents(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`;
}

export function StatCard({ 
  title, 
  value, 
  description, 
  icon: Icon, 
  trend,
  trendDirection,
  color = "primary"
}: { 
  title: string; 
  value: string | number; 
  description: string; 
  icon: any;
  trend?: string;
  trendDirection?: "up" | "down" | "neutral";
  color?: "primary" | "green" | "yellow" | "red" | "blue" | "purple";
}) {
  const colorClasses = {
    primary: "text-primary",
    green: "text-green-600",
    yellow: "text-yellow-600",
    red: "text-red-600",
    blue: "text-blue-600",
    purple: "text-purple-600",
  };

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2 gap-2">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
        <Icon className={`h-4 w-4 ${colorClasses[color]}`} />
      </CardHeader>
      <CardContent>
        <div className={`text-2xl font-bold ${colorClasses[color]}`}>{value}</div>
        <div className="flex items-center gap-2 mt-1">
          <p className="text-xs text-muted-foreground">{description}</p>
          {trend && (
            <Badge variant="secondary" className="text-xs">
              {trendDirection === "up" && <TrendingUp className="w-3 h-3 mr-1" />}
              {trendDirection === "down" && <TrendingDown className="w-3 h-3 mr-1" />}
              {trend}
            </Badge>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
